import AdminLayout from '../components/AdminLayout';

export default function MaintenancePage() {
  return (
    <AdminLayout title="מצב תחזוקה" subtitle="האתר במצב תחזוקה">
      <div className="flex flex-col items-center justify-center py-20 text-center max-w-lg mx-auto">
        <div className="w-20 h-20 flex items-center justify-center rounded-3xl bg-amber-50 border-2 border-amber-100 mb-5">
          <i className="ri-tools-line text-4xl text-amber-400"></i>
        </div>
        <h2 className="text-xl font-bold text-gray-800 mb-2">האתר במצב תחזוקה</h2>
        <p className="text-sm text-gray-500 mb-6">מבקרים הרואים את האתר יופנו לדף תחזוקה. רק משתמשים מחוברים יוכלו לגשת למערכת הניהול.</p>
        <div className="flex items-center gap-3 px-5 py-3 bg-amber-50 border-2 border-amber-100 rounded-2xl">
          <div className="w-2 h-2 rounded-full bg-amber-400 animate-pulse"></div>
          <span className="text-sm font-semibold text-amber-600">מצב תחזוקה פעיל</span>
        </div>
      </div>
    </AdminLayout>
  );
}
